export const PUBLIC_PRIVACY_POLICY_URL =
  "https://www.dashcore.cl/pol%C3%ADtica-de-privacidad";
